export const EVideoRecordingStatus = {
  INITIAL: 'initial',
  STARTED: 'started',
  PAUSED: 'paused',
  STOPPED: 'stopped',
  COMPLETED: 'completed',
  UPLOADING: 'uploading',
  UPLOADED: 'uploaded',
  FAILED: 'failed',
  RECORD: 'record',
  STOP: 'stop',
  PAUSE: 'pause',
  RESUME: 'resume',
  SUBMIT: 'submit',
  SUBMITTING: 'submitting',
  UPLOAD: 'upload',
  RERECORD: 're-record',
  START: 'start',
};

const mimeTypes = ['video/webm', 'video/mp4'];

export const VIDEO_DB = 'videoDB';
export const VIDEO_STORE = 'videoStore';

const supportedMimeType = mimeTypes.find(type =>
  MediaRecorder.isTypeSupported(type)
);

export const indexedDBError = {
  getItemErrorText: 'Unable to get video from IndexedDB',
  setItemErrorText: 'Unable to save video in IndexedDB',
  removeItemErrorText: 'Unable to remove video from IndexedDB',
  dbDeleteErrorText: 'Unable to delete Video IndexedDB!',
};

export const videoSolution = {
  CAM_ACCESS_REQUIRED: 'Camera and microphone permissions are required!',
  DESCRIPTION: 'Description',
  GRANT_CAM_ACCESS:
    'Please grant Camera and microphone permission, then reload the page.',
  RECORD_DURATION: 'Record duration:',
  SECOND: 'Seconds',
  SAVE_YOUR_CHANGES:
    'Are you sure you want to leave this page?\nYou have unsaved changes.Click on Cancel to go back and save the changes.',
  MEDIA_TYPE: supportedMimeType,
  UPLOAD_MEDIA_TYPE: 'video/webm',
  MEDIA_DESCRIPTION: {
    audioBitsPerSecond: 128000,
    videoBitsPerSecond: 1500000,
    mimeType: supportedMimeType,
  },
  WARNING_TEXT:
    ' Depending on your network, submission can take a while. Please submit before timer runs out.',
  VIDEO_UPLOAD_ERROR: 'video upload error',
  DISCARD_PROCEED: 'Discard and Proceed',
  REPLACE_VIDEO: 'Replace video',
  ALREADY_UPLOADED_MESSAGE:
    'A video is already uploaded. Do you want to replace the uploaded video with the new video?',
  UPLOAD_VIDEO: 'Upload video',
  UPLOAD_MESSAGE: 'Would you like to upload the video that you recorded?',
};
export const EVideoProblemModalAction = {
  UPLOAD: 'upload',
  DISCARD: 'discard',
};
